import React from "react";

const SectionHeader = ({
  badgeText,
  badgeIcon = "dot", // 'dot' or a React element/SVG
  title,
  titleAs = "h2", // 'h1' or 'h2'
  subtitle,
  className = "",
  badgeClassName = "",
  titleClassName = "",
  subtitleClassName = "",
  decorativeLineClassName = "mb-6", // Customizable margin for decorative line
}) => {
  const TitleTag = titleAs;

  return (
    <div className={`text-center mb-12 sm:mb-16 lg:mb-20 ${className}`}>
      {/* Badge */}
      <div
        className={`inline-flex items-center gap-2 bg-primary-100 px-4 py-2 rounded-full mb-4 ${badgeClassName}`}
        data-aos="fade-down"
        data-aos-duration="600"
      >
        {badgeIcon === "dot" ? (
          <span className="w-2 h-2 bg-primary-400 rounded-full animate-pulse"></span>
        ) : (
          badgeIcon
        )}
        <span className="text-primary-600 text-xs sm:text-sm font-bold tracking-wide uppercase">
          {badgeText}
        </span>
      </div>

      {/* Title */}
      <TitleTag
        className={`text-neutral-900 font-extrabold text-3xl 2xsm:text-4xl md:text-5xl lg:text-6xl mb-4 sm:mb-6 bg-gradient-to-r from-neutral-900 via-primary-900 to-neutral-900 bg-clip-text text-transparent py-2 ${titleClassName}`}
        data-aos="zoom-in"
        data-aos-offset="200"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="800"
      >
        {title}
      </TitleTag>

      {/* Decorative Line */}
      <div
        className={`flex items-center justify-center gap-3 ${decorativeLineClassName}`}
        data-aos="fade-in"
        data-aos-duration="800"
        data-aos-delay="300"
      >
        <div className="flex items-center gap-1">
          <div className="w-2 h-2 bg-primary-400 rounded-full"></div>
          <div className="w-16 sm:w-24 h-0.5 bg-gradient-to-r from-primary-400 to-transparent"></div>
        </div>
        <div className="w-3 h-3 bg-primary-400 rounded-full animate-pulse shadow-lg shadow-primary-400/50"></div>
        <div className="flex items-center gap-1">
          <div className="w-16 sm:w-24 h-0.5 bg-gradient-to-l from-primary-400 to-transparent"></div>
          <div className="w-2 h-2 bg-primary-400 rounded-full"></div>
        </div>
      </div>

      {/* Subtitle (optional) */}
      {subtitle && (
        <p
          className={`text-neutral-700 text-xs sm:text-sm md:text-base lg:text-lg leading-relaxed max-w-4xl mx-auto font-medium ${subtitleClassName}`}
          data-aos="fade-up"
          data-aos-delay="400"
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;

